<template>
  <div>
    <div class="d-flex justify-content-between">
      <h4>Маршруты</h4>
      <div>
        <b-button variant="outline-primary" class="mr-2" @click="changeOrderClicked">
          Изменить порядок
        </b-button>
        <b-button variant="outline-primary" @click="addClicked">Добавить</b-button>
      </div>
    </div>
    <b-form class="search-form mt-3" @submit.prevent="searchRoutes">
      <b-input-group>
        <b-form-input v-model.trim="search" placeholder="Поиск по названию" />
        <b-input-group-append>
          <b-button type="submit" variant="outline-primary">Найти</b-button>
          <b-button v-if="search" variant="outline-secondary" @click="clearSearch">
            Очистить
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
    <list-skeleton v-if="loading" :columns="4" />
    <b-table
      v-else
      class="routes-table mt-3"
      :fields="fields"
      :items="list"
      @row-clicked="(row) => rowClicked(row)"
      tbody-tr-class="pointer"
    >
      <template #cell(description)="{ value }">
        <div class="restricted-height">{{ value }}</div>
      </template>
      <template #cell(author)="{ value }">
        <span>{{ value }}</span>
      </template>
      <template #cell(actions)="{ item }">
        <div class="table-actions">
          <button type="button" class="action-button action-edit" @click.stop="rowClicked(item)">
            <b-icon class="action-icon" icon="pen" />
            <span>Изменить</span>
          </button>
          <button
            type="button"
            class="action-button action-delete"
            @click.stop="deleteClicked(item, $event)"
          >
            <b-icon class="action-icon" icon="trash2" />
            <span>Удалить</span>
          </button>
        </div>
      </template>
    </b-table>
    <div class="d-flex justify-content-center">
      <b-pagination
        class="m-auto"
        v-model="currentPage"
        :disabled="loading"
        :total-rows="total"
        per-page="25"
      />
    </div>
  </div>
</template>

<script>
import { Routes } from '@/request';
import ListSkeleton from '@/components/ListSkeleton.vue';

export default {
  name: 'Routes',
  components: { ListSkeleton },
  data() {
    return {
      list: [],
      loading: true,
      fields: [
        { key: 'title', label: 'Название', thStyle: { width: '28%' } },
        {
          key: 'description',
          label: 'Описание',
          thStyle: { width: '30%' },
          tdClass: 'description-column',
        },
        {
          key: 'author',
          label: 'Автор',
          formatter: this.formatAuthor,
          thStyle: { width: '24%' },
        },
        { key: 'actions', label: '', thStyle: { width: '18%' } },
      ],
      currentPage: 1,
      total: 0,
      search: '',
    };
  },
  mounted() {
    this.loadRoutes(this.currentPage);
  },
  methods: {
    async loadRoutes(page) {
      this.loading = true;
      try {
        const { data, total } = await Routes.getRoutes({
          page,
          search: this.search || undefined,
        });
        this.list = data;
        this.total = total;
      } catch (e) {
        this.$bvToast.toast(e.message, { variant: 'danger' });
      } finally {
        this.loading = false;
      }
    },
    addClicked() {
      this.$router.push({ name: 'NewRoute' });
    },
    changeOrderClicked() {
      this.$router.push({ name: 'RoutesOrder' });
    },
    searchRoutes() {
      if (this.currentPage === 1) {
        this.loadRoutes(1);
      } else {
        this.currentPage = 1;
      }
    },
    clearSearch() {
      this.search = '';
      this.searchRoutes();
    },
    rowClicked(row, event = undefined) {
      event?.stopPropagation();

      this.$router.push({ name: 'EditRoute', params: { id: row.id } });
    },
    async deleteClicked(row, event) {
      event?.stopPropagation();

      const userAgreed = await this.$bvModal.msgBoxConfirm(
        `Вы действительно хотите удалить маршрут: ${row.title}?`,
        {
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          cancelVariant: 'outline-secondary',
        },
      );

      if (!userAgreed) {
        return;
      }

      try {
        this.updatingPointPosition = true;
        await Routes.deleteRoute(row.id);
        this.$bvToast.toast('Маршрут удален', { variant: 'success' });
        await this.loadRoutes();
      } catch (e) {
        this.$bvToast.toast(e.message, { variant: 'danger' });
      }
    },
    formatAuthor(author) {
      return author ? `${author?.first_name} ${author?.last_name}` : 'Не указан';
    },
  },
  watch: {
    currentPage(newVal) {
      this.loadRoutes(newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.restricted-height {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-form {
  max-width: 600px;
}
</style>
